// extracted by mini-css-extract-plugin
module.exports = {"wrap":"nb-z","heading":"ob-z"};